// import React, { useState, useEffect } from 'react'
// import axios from 'axios'
// import {
//   Container,
//   Form,
//   Button,
//   DropdownButton,
//   Dropdown,
// } from 'react-bootstrap'
// import {
//   BsPersonFill,
//   BsGlobe,
//   BsPeople,
//   BsLock,
//   BsPencil,
//   BsPerson,
//   BsImage,
// } from 'react-icons/bs'
// import Header from '../Components/Header.jsx'
// import StudentSdebar from './StudentSdebar.jsx'
// import ProfilePhoto from '../Components/EditProfileSection/ProfilePhoto.jsx'
// import CoverPhoto from '../Components/EditProfileSection/CoverPhoto.jsx'
// import { Link } from 'react-router-dom'
// import { motion, AnimatePresence } from "framer-motion"


// const API_URL = 'https://kaasbackend.vetrinahealthcare.com/lms/user/'

// const AdvancedDropdown = ({ visibility, onChange }) => {
//   const options = [
//     { key: 'Public', label: 'Public', icon: <BsGlobe /> },
//     { key: 'All Members', label: 'All Members', icon: <BsPeople /> },
//     { key: 'My Connections', label: 'My Connections', icon: <BsPersonFill /> },
//     { key: 'Only Me', label: 'Only Me', icon: <BsLock /> },
//   ]

//   return (
//     <DropdownButton
//       id='advanced-dropdown'
//       // title="Change"
//       title={
//         options.find((option) => option.key === visibility)?.label || 'Change'
//       }
//       variant='outline-secondary'
//       className='p-0'
//       align='end'
//     >
//       {options.map((option) => (
//         <Dropdown.Item
//           key={option.key}
//           eventKey={option.key}
//           active={visibility === option.key}
//           onClick={() => onChange(option.key)}
//           className='d-flex align-items-center'
//         >
//           {option.icon}
//           <span className='ms-2'>{option.label}</span>
//           {visibility === option.key && (
//             <i className='bi bi-check text-success ms-auto'></i>
//           )}
//         </Dropdown.Item>
//       ))}
//     </DropdownButton>
//   )
// }

// const EditProfile = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     nickname: '',
//     visibility: 'Public',
//   })

//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState('')
//   const [activeSection, setActiveSection] = useState('edit')
//   const token = localStorage.getItem('jwttoken')
//   const [sidebarExpanded, setSidebarExpanded] = useState(false);

//   // Fetch user data
//   useEffect(() => {
//     const fetchUserData = async () => {
//       if (!token) {
//         setError('User not authenticated')
//         setLoading(false)
//         return
//       }
//       try {
//         const response = await axios.get(API_URL, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         })
//         const userData = response.data
//         setFormData({
//           firstName: userData.first_name || '',
//           lastName: userData.last_name || '',
//           nickname: userData.nickname || '',
//           visibility: 'Public', // Default visibility
//         })
//       } catch (err) {
//         setError(err.response?.data?.message || 'Failed to load user data')
//       } finally {
//         setLoading(false)
//       }
//     }

//     fetchUserData()
//   }, [token])

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     })
//   }

//   const handleVisibilityChange = (newVisibility) => {
//     setFormData({ ...formData, visibility: newVisibility })
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     try {
//       await axios.patch(
//         API_URL,
//         {
//           first_name: formData.firstName,
//           last_name: formData.lastName,
//           nickname: formData.nickname,
//           visibility: formData.visibility,
//         },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       )

//       alert('Profile updated successfully')
//     } catch (err) {
//       alert('Failed to update profile')
//     }
//   }

//   const renderSection = () => {
//     if (loading) return <p>Loading...</p>
//     if (error) return <p>{error}</p>

//     switch (activeSection) {
//       case 'profile-photo':
//         return <ProfilePhoto />
//       case 'cover-photo':
//         return <CoverPhoto />
//       default:
//         return (
//           <>
//             <h2 className='h5 mb-4'>Edit "Details" Information</h2>
//             <Form onSubmit={handleSubmit}>
//               <Form.Group className='mb-4'>
//                 <Form.Label>First Name (required)</Form.Label>
//                 <Form.Control
//                   type='text'
//                   name='firstName'
//                   value={formData.firstName}
//                   onChange={handleChange}
//                   required
//                   className='mb-2'
//                 />
//                 <Form.Text className='text-muted'>Public</Form.Text>
//               </Form.Group>

//               <Form.Group className='mb-4'>
//                 <Form.Label>Last Name (required)</Form.Label>
//                 <Form.Control
//                   type='text'
//                   name='lastName'
//                   value={formData.lastName}
//                   onChange={handleChange}
//                   required
//                   className='mb-2'
//                 />
//                 <div className='d-flex align-items-center'>
//                   <Form.Text className='text-muted me-2'>
//                     Visibility: {formData.visibility}
//                   </Form.Text>
//                   <AdvancedDropdown
//                     visibility={formData.visibility}
//                     onChange={handleVisibilityChange}
//                   />
//                 </div>
//               </Form.Group>

//               <Form.Group className='mb-4'>
//                 <Form.Label>Nickname (required)</Form.Label>
//                 <Form.Control
//                   type='text'
//                   name='nickname'
//                   value={formData.nickname}
//                   onChange={handleChange}
//                   required
//                   className='mb-2'
//                 />
//                 <Form.Text className='text-muted'>Public</Form.Text>
//               </Form.Group>

//               <Button
//                 variant='primary'
//                 type='submit'
//                 className='px-4 py-2 hover-light-grey'
//               >
//                 Save Changes
//               </Button>
//             </Form>
//           </>
//         )
//     }
//   }

//   return (
//     <div className='min-h-screen bg-light'>
//       <Header />
//       <div className="wrapper" style={{ display: "flex" }}>
//       <StudentSdebar onToggle={setSidebarExpanded} />

//       <motion.div
//         className="main-content p-lg-4 p-md-3 p-2"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 0.5 }}
//         style={{
//           marginTop: '60px', // Adjust this to match your Header height
//           marginLeft: sidebarExpanded ? '260px' : '90px',
//           transition: 'margin-left 0.25s ease-in-out',
//           width: sidebarExpanded ? 'calc(100% - 260px)' : 'calc(100% - 90px)',
//           overflowY: 'auto',
//           height: 'calc(100vh - 60px)',
//         }}
//       >
//         <div className='flex-grow-1 p-4'>
//           <div className='d-flex justify-content-between align-items-center mb-4'>
//             <h1 className='h3 mb-0'>Edit Profile</h1>
//             {/* <Button variant="light" className="d-flex align-items-center gap-2 border hover-light-grey">
//               <i className="bi bi-eye"></i>
//               View Profile
//             </Button> */}
//             <Button
//               variant='light'
//               className='d-flex align-items-center gap-2 border hover-light-grey'
//             >
//               <Link
//                 to='/profilenew'
//                 className='text-decoration-none text-dark d-flex align-items-center gap-2'
//               >
//                 <i className='bi bi-eye'></i>
//                 View Profile
//               </Link>
//             </Button>
//           </div>
//           <Container fluid className='custom-container'>
//             <div className='bg-white rounded shadow-sm p-4 mb-4 d-flex'>
//               <ul
//                 className='list-unstyled mb-0'
//                 style={{
//                   minWidth: '200px',
//                   borderRight: '1px solid #d3d3d3',
//                   paddingRight: '16px',
//                 }}
//               >
//                 <li className='mb-3'>
//                   <a
//                     href='#edit'
//                     className={`text-decoration-none d-flex align-items-center ${
//                       activeSection === 'edit'
//                         ? 'text-primary fw-bold'
//                         : 'text-dark'
//                     }`}
//                     onClick={(e) => {
//                       e.preventDefault()
//                       setActiveSection('edit')
//                     }}
//                   >
//                     <BsPencil className='me-2' /> Edit
//                   </a>
//                 </li>
//                 <li className='mb-3'>
//                   <a
//                     href='#profile-photo'
//                     className={`text-decoration-none d-flex align-items-center ${
//                       activeSection === 'profile-photo'
//                         ? 'text-primary fw-bold'
//                         : 'text-dark'
//                     }`}
//                     onClick={(e) => {
//                       e.preventDefault()
//                       setActiveSection('profile-photo')
//                     }}
//                   >
//                     <BsPerson className='me-2' /> Profile Photo
//                   </a>
//                 </li>
//                 <li className='mb-3'>
//                   <a
//                     href='#cover-photo'
//                     className={`text-decoration-none d-flex align-items-center ${
//                       activeSection === 'cover-photo'
//                         ? 'text-primary fw-bold'
//                         : 'text-dark'
//                     }`}
//                     onClick={(e) => {
//                       e.preventDefault()
//                       setActiveSection('cover-photo')
//                     }}
//                   >
//                     <BsImage className='me-2' /> Cover Photo
//                   </a>
//                 </li>
//               </ul>
//               <div className='flex-grow-1 ps-4'>{renderSection()}</div>
//             </div>
//           </Container>
//         </div>
//         </motion.div>
//       </div>
//     </div>
//   )
// }

// export default EditProfile


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Container,
  Form,
  Button,
  DropdownButton,
  Dropdown,
  Spinner, // Import Spinner for the button loader
} from 'react-bootstrap';
import {
  BsPersonFill,
  BsGlobe,
  BsPeople,
  BsLock,
  BsPencil,
  BsPerson,
  BsImage,
} from 'react-icons/bs';
import Header from '../Components/Header.jsx'; // Assuming this path is correct
import StudentSdebar from './StudentSdebar.jsx'; // Assuming this path is correct
import ProfilePhoto from '../Components/EditProfileSection/ProfilePhoto.jsx'; // Assuming this path is correct
import CoverPhoto from '../Components/EditProfileSection/CoverPhoto.jsx'; // Assuming this path is correct
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

import Swal from 'sweetalert2'; // Still needed for other alerts (e.g., initial load error, save success/failure)


const API_URL = 'https://kaasbackend.vetrinahealthcare.com/lms/user/';

const AdvancedDropdown = ({ visibility, onChange }) => {
  const options = [
    { key: 'Public', label: 'Public', icon: <BsGlobe /> },
    { key: 'All Members', label: 'All Members', icon: <BsPeople /> },
    { key: 'My Connections', label: 'My Connections', icon: <BsPersonFill /> },
    { key: 'Only Me', label: 'Only Me', icon: <BsLock /> },
  ];

  return (
    <DropdownButton
      id='advanced-dropdown'
      title={
        options.find((option) => option.key === visibility)?.label || 'Change'
      }
      variant='outline-secondary'
      className='p-0'
      align='end'
    >
      {options.map((option) => (
        <Dropdown.Item
          key={option.key}
          eventKey={option.key}
          active={visibility === option.key}
          onClick={() => onChange(option.key)}
          className='d-flex align-items-center'
        >
          {option.icon}
          <span className='ms-2'>{option.label}</span>
          {visibility === option.key && (
            <i className='bi bi-check text-success ms-auto'></i>
          )}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
};

const EditProfile = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    nickname: '',
    visibility: 'Public', // Default visibility
  });

  const [loading, setLoading] = useState(true); // For initial profile data fetch
  const [isSaving, setIsSaving] = useState(false); // For "Save Changes" button loader
  const [error, setError] = useState('');
  const [activeSection, setActiveSection] = useState('edit');
  const [sidebarExpanded, setSidebarExpanded] = useState(false);

  const token = localStorage.getItem('jwttoken');

  // Fetch user data
  useEffect(() => {
    const fetchUserData = async () => {
      if (!token) {
        setError('User not authenticated');
        setLoading(false);
        return;
      }

      // Show initial loading dialog for fetching profile data
      Swal.fire({
        title: 'Loading profile...',
        html: `
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-3">Please wait while we load your profile data</p>
        `,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      try {
        const response = await axios.get(API_URL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const userData = response.data;
        setFormData({
          firstName: userData.first_name || '',
          lastName: userData.last_name || '',
          nickname: userData.nickname || '',
          visibility: userData.visibility || 'Public', // Use actual visibility from backend if available
        });
        Swal.close(); // Close loading dialog on success
      } catch (err) {
        Swal.close(); // Close loading dialog on error
        setError(err.response?.data?.message || 'Failed to load user data');
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: err.response?.data?.message || 'Failed to load profile data. Please try again.',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [token]); // Dependencies: only re-run if token changes

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleVisibilityChange = (newVisibility) => {
    setFormData({ ...formData, visibility: newVisibility });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true); // Start saving animation
    
    // REMOVED: Swal.fire for saving dialog.
    // The button itself will show the loader.

    try {
      await axios.patch(
        API_URL,
        {
          first_name: formData.firstName,
          last_name: formData.lastName,
          nickname: formData.nickname,
          visibility: formData.visibility, // Send visibility with the patch request
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // REMOVED: Swal.close() here as there was no Swal.fire before it.
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Profile updated successfully!',
        timer: 2000, // Auto-close after 2 seconds
        timerProgressBar: true,
      });
    } catch (err) {
      // REMOVED: Swal.close() here as there was no Swal.fire before it.
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: err.response?.data?.message || 'Failed to update profile. Please try again.',
      });
    } finally {
      setIsSaving(false); // Stop saving animation regardless of success or failure
    }
  };

  const renderSection = () => {
    if (loading) return <p>Loading...</p>;
    if (error) return <p className="text-danger">{error}</p>;

    switch (activeSection) {
      case 'profile-photo':
        return <ProfilePhoto />;
      case 'cover-photo':
        return <CoverPhoto />;
      default:
        return (
          <>
            <h2 className='h5 mb-4'>Edit "Details" Information</h2>
            <Form onSubmit={handleSubmit}>
              <Form.Group className='mb-4'>
                <Form.Label>First Name (required)</Form.Label>
                <Form.Control
                  type='text'
                  name='firstName'
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  className='mb-2'
                />
                <Form.Text className='text-muted'>Public</Form.Text>
              </Form.Group>

              <Form.Group className='mb-4'>
                <Form.Label>Last Name (required)</Form.Label>
                <Form.Control
                  type='text'
                  name='lastName'
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  className='mb-2'
                />
                <div className='d-flex align-items-center'>
                  <Form.Text className='text-muted me-2'>
                    Visibility: {formData.visibility}
                  </Form.Text>
                  <AdvancedDropdown
                    visibility={formData.visibility}
                    onChange={handleVisibilityChange}
                  />
                </div>
              </Form.Group>

              <Form.Group className='mb-4'>
                <Form.Label>Nickname (required)</Form.Label>
                <Form.Control
                  type='text'
                  name='nickname'
                  value={formData.nickname}
                  onChange={handleChange}
                  required
                  className='mb-2'
                />
                <Form.Text className='text-muted'>Public</Form.Text>
              </Form.Group>

              <Button
                variant='primary'
                type='submit'
                className='px-4 py-2'
                disabled={isSaving} // Disable button while saving
              >
                {isSaving ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    <span className="ms-2">Saving...</span>
                  </>
                ) : (
                  'Save Changes'
                )}
              </Button>
            </Form>
          </>
        );
    }
  };

  return (
    <div className='min-h-screen bg-light'>
      <Header />
      <div className="wrapper" style={{ display: "flex" }}>
        <StudentSdebar onToggle={setSidebarExpanded} />

        <motion.div
          className="main-content p-lg-4 p-md-3 p-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            marginTop: '60px',
            marginLeft: sidebarExpanded ? '260px' : '90px',
            transition: 'margin-left 0.25s ease-in-out',
            width: sidebarExpanded ? 'calc(100% - 260px)' : 'calc(100% - 90px)',
            overflowY: 'auto',
            height: 'calc(100vh - 60px)',
          }}
        >
          <div className='flex-grow-1 p-4'>
            <div className='d-flex justify-content-between align-items-center mb-4'>
              <h1 className='h3 mb-0'>Edit Profile</h1>
              <Button
                variant='light'
                className='d-flex align-items-center gap-2 border hover-light-grey'
              >
                <Link
                  to='/profilenew'
                  className='text-decoration-none text-dark d-flex align-items-center gap-2'
                >
                  <i className='bi bi-eye'></i>
                  View Profile
                </Link>
              </Button>
            </div>
            <Container fluid className='custom-container'>
              <div className='bg-white rounded shadow-sm p-4 mb-4 d-flex'>
                <ul
                  className='list-unstyled mb-0'
                  style={{
                    minWidth: '200px',
                    borderRight: '1px solid #d3d3d3',
                    paddingRight: '16px',
                  }}
                >
                  <li className='mb-3'>
                    <a
                      href='#edit'
                      className={`text-decoration-none d-flex align-items-center ${
                        activeSection === 'edit'
                          ? 'text-primary fw-bold'
                          : 'text-dark'
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveSection('edit');
                      }}
                    >
                      <BsPencil className='me-2' /> Edit
                    </a>
                  </li>
                  <li className='mb-3'>
                    <a
                      href='#profile-photo'
                      className={`text-decoration-none d-flex align-items-center ${
                        activeSection === 'profile-photo'
                          ? 'text-primary fw-bold'
                          : 'text-dark'
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveSection('profile-photo');
                      }}
                    >
                      <BsPerson className='me-2' /> Profile Photo
                    </a>
                  </li>
                  <li className='mb-3'>
                    <a
                      href='#cover-photo'
                      className={`text-decoration-none d-flex align-items-center ${
                        activeSection === 'cover-photo'
                          ? 'text-primary fw-bold'
                          : 'text-dark'
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveSection('cover-photo');
                      }}
                    >
                      <BsImage className='me-2' /> Cover Photo
                    </a>
                  </li>
                </ul>
                <div className='flex-grow-1 ps-4'>{renderSection()}</div>
              </div>
            </Container>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default EditProfile;